function Dipespderechoprocedimiento() {
     return(
        <div className="contenedor">
            <div className="presentacion"> 
               <h1> Presentación </h1>
               <p>
                    El Diploma de Especialización en Derecho Administrativo y Procedimiento 
                    Administrativo brinda formación integral sobre la normativa, principios 
                    y procedimientos que regulan la actuación administrativa en el sector público.
               </p>
               <p>
                    El programa desarrolla contenidos vinculados a actos administrativos, 
                    procedimientos sancionadores, recursos administrativos y responsabilidad administrativa.
               </p>

                <ul>
                    <h1> Objetivo Específico </h1>
                    <ul>
                        <li>
                            Desarrollar competencias técnicas para aplicar correctamente la normativa 
                            y los procedimientos administrativos asegurando legalidad y transparencia.
                        </li>
                    </ul>
                </ul>
            </div>

            <div className="metedologia">
                <img src='/uploads/curs_derecho_penal_publica.jpg' alt='logo-de-metodologia' className='logo-metodologia'/>
                <ul> 
                    <li>
                        <h1> Informes </h1>
                        <p>Escuela de Gerencia y Gestión S.A.C</p>
                        <p>📱 913376365 / 948251685</p>
                        <p>📧 esscuelag@gmail.com | capacita@escuelag.com</p>
                    </li>
                </ul>
            </div>

            <div className="temario-principal">
                <h1> Áreas Temáticas </h1>
                <ul>
                    <li> 1. Principios del Derecho Administrativo </li>
                    <li> 2. Actos Administrativos </li>
                    <li> 3. Procedimientos Sancionadores </li>
                    <li> 4. Recursos Administrativos </li>
                    <li> 5. Responsabilidad Administrativa </li>
                </ul>
            </div>
        </div>
    );
}
export default Dipespderechoprocedimiento
